import React from 'react'
import styled from 'styled-components'
import { LayoutContentWrapper } from 'components/LayoutContentWrapper/LayoutContentWrapper'
import { breakpointFrom, breakpointUpTo } from 'utils/breakpoints'

type Props = {
  text: string
}

const StyledContainer = styled.section`
  margin: 108px 0;

  ${({ theme }) => breakpointUpTo(theme.breakpoints.lg)} {
    margin: ${({ theme }) => theme.space[7]} 0;
  }

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    margin: ${({ theme }) => theme.space[5]} 0;
  }
`

const StyledText = styled.p`
  ${({ theme }) => theme.typography.SmBody3};
  text-align: center;
  opacity: 0.48;

  ${({ theme }) => breakpointFrom(theme.breakpoints.md)} {
    ${({ theme }) => theme.typography.MedBody3};
  }

  ${({ theme }) => breakpointFrom(theme.breakpoints.lg)} {
    ${({ theme }) => theme.typography.LrgBody3};
  }

  ${({ theme }) => breakpointFrom(theme.breakpoints.xl)} {
    ${({ theme }) => theme.typography.XLBody3};
  }
`

export const PromoDisclaimerSection = ({ text }: Props) => {
  return (
    <StyledContainer>
      <LayoutContentWrapper>
        <StyledText>{text}</StyledText>
      </LayoutContentWrapper>
    </StyledContainer>
  )
}
